import SpriteSymbol from "../../../../../../../../../../ldplatform/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../ldplatform/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collapse",
  "use": "icon-collapse-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-collapse\"><path d=\"M0 0v1024h1024V0z m921.6 921.6H102.4V102.4h819.2z\" p-id=\"6030\" /><path d=\"M460.8 819.2h102.4V563.2H819.2v-102.4H563.2V204.8h-102.4v256H204.8v102.4h256V819.2z\" p-id=\"6031\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol